module.exports = __webpack_public_path__ + "media/icons/tie-1bb194d9.png";